(function($) {

$(document).ready(function() {

  // open and close search
  $('.open-search').click(function(){
    $('#search-field').toggleClass('open');
    $('.cart-link').toggle();
  });

	var $container = $('#grid-outlet');

	$container.imagesLoaded( function(){
	  $container.masonry({
	    itemSelector : '.item'
	  });
	});

});

} )( jQuery );